import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/auth/Login';
import Dashboard from './pages/dashboard/Dashboard';
import Users from './pages/users/Users';
import Districts from './pages/districts/Districts';
import Institutions from './pages/institutions/Institutions';
import BulkImport from './pages/institutions/BulkImport';
import Attendance from './pages/attendance/Attendance';
import Reports from './pages/reports/Reports';
import ReportPrintView from './pages/reports/ReportPrintView';
import AuditLog from './pages/audit/AuditLog';
import MonitoringAgent from './pages/agents/MonitoringAgent';
import KnowledgeBase from './pages/knowledge/KnowledgeBase';
import AssignmentWorkflow from './pages/assignments/AssignmentWorkflow';
import BaselineReview from './pages/assignments/BaselineReview';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-blue-800 text-xl font-semibold">Loading FMAS...</div>
    </div>
  );
  if (!user) return <Navigate to="/login" />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute><Users /></ProtectedRoute>} />
          <Route path="/districts" element={<ProtectedRoute><Districts /></ProtectedRoute>} />
          <Route path="/institutions" element={<ProtectedRoute><Institutions /></ProtectedRoute>} />
          <Route path="/institutions/bulk-import" element={<ProtectedRoute><BulkImport /></ProtectedRoute>} />
          <Route path="/attendance" element={<ProtectedRoute><Attendance /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
          <Route path="/reports/:id/print" element={<ProtectedRoute><ReportPrintView /></ProtectedRoute>} />
          <Route path="/audit" element={<ProtectedRoute><AuditLog /></ProtectedRoute>} />
          <Route path="/agents/monitoring" element={<ProtectedRoute><MonitoringAgent /></ProtectedRoute>} />
          <Route path="/knowledge" element={<ProtectedRoute><KnowledgeBase /></ProtectedRoute>} />
          <Route path="/assignments" element={<ProtectedRoute><AssignmentWorkflow /></ProtectedRoute>} />
          <Route path="/assignments/baseline-review" element={<ProtectedRoute><BaselineReview /></ProtectedRoute>} />
          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;